(function () {
  function initCardFamilyThumbs(root) {
    var containers = (root || document).querySelectorAll('[data-card-family-thumbs]');
    containers.forEach(function (container) {
      if (container.dataset.thumbsInit) return;
      container.dataset.thumbsInit = 'true';

      var card = container.closest('.card-wrapper') || container.parentElement;
      var mainImg = card ? card.querySelector('.card__media img') : null;
      if (!mainImg) return;

      var originalSrc = mainImg.getAttribute('src');
      var originalSrcset = mainImg.getAttribute('srcset');

      container.querySelectorAll('.card-family-thumbs__item').forEach(function (thumb) {
        thumb.addEventListener('mouseenter', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          var fullSrcset = thumb.getAttribute('data-full-srcset');
          if (fullSrc) mainImg.setAttribute('src', fullSrc);
          if (fullSrcset) mainImg.setAttribute('srcset', fullSrcset);
        });
        thumb.addEventListener('mouseleave', function () {
          if (originalSrc) mainImg.setAttribute('src', originalSrc);
          if (originalSrcset) mainImg.setAttribute('srcset', originalSrcset);
        });
        thumb.addEventListener('click', function (e) {
          // Let the click navigate normally to the sibling product page.
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCardFamilyThumbs(document);
  });

  // Re-init after Shopify section re-renders (theme editor, infinite scroll, filters, etc.)
  document.addEventListener('shopify:section:load', function (e) {
    initCardFamilyThumbs(e.target);
  });
})();
